import { render, staticRenderFns } from "./carrier-master.vue?vue&type=template&id=95081dae&scoped=true&"
import script from "./js/carrier-master.js?vue&type=script&lang=js&"
export * from "./js/carrier-master.js?vue&type=script&lang=js&"
import style0 from "./carrier-master.vue?vue&type=style&index=0&id=95081dae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95081dae",
  null
  
)

export default component.exports